export default __webpack_public_path__ + "static/media/Memoji.d34d7c53.png";